import type { TFunction } from "@/hooks/useTranslation"

export const getRequiredFieldRule = (t: TFunction) => ({
  required: true,
  message: t("error.requiredField")
})

export const getNoCommasRule = (t: TFunction) => ({
  validator: (_: unknown, value: string) => {
    if (value && value.includes(",")) {
      return Promise.reject(new Error(t("error.noCommasAllowed")))
    }
    return Promise.resolve()
  }
})
